import* as workOrdersService from '../../services/WorkOrders/workOrdersService';
import DateTimeHelper from "../../../../infrastructure/js/utils/dateTimeHelper";
import * as gridActionsHelper from "infrastructure/js/components/Grid/Utils/gridActionsHelper";
import {gridsNames} from "../../enums/gridsNames";
const gridActions = gridActionsHelper.getGridActions(gridsNames.WO_PAGE_ACTIVITY_LOG, _fetchDataAction, _convertToRowData);
import * as ValueTypeConverter from "../../components/Common/Helpers/valueTypeConverter";
import {createLabelHelper} from "../../../../infrastructure/js/utils/labelHelper";

function _fetchDataAction(query) {
  return function(dispatch, getState) {
    let workOrderId = getState().workOrderPage.getIn(['data', 'workOrder' , 'id']);
    return workOrdersService.getworkOrderActivityLog(workOrderId,query);
  }
};

function _convertToRowData(rows, serverTimeSeconds) {
  let labels = createLabelHelper('mat.activitydetails.');
  let convertedRows = rows.map((row) => {
    row.m_Time = DateTimeHelper.FormatDateObjectToRelativeTime(row.time, serverTimeSeconds);
    if(row.extendedDetails){
      row.isRowMaster = row.extendedDetails.length > 0;
      row.extendedDetails.map((detail) => {
        detail.title = detail.keyIsReadyForDisplay ? detail.key : labels.get(detail.key);
        detail.value = ValueTypeConverter.getValueByType(detail.value, detail.valuetype);
      });
    }

    return row;
  });

  return convertedRows;
};

export let actionTypes = gridActions.actionTypes, api = gridActions.apiActions, jsxActions = gridActions.jsxActions;
